import { MatchData } from '@/interfaces/liveGamesType';

export interface League {
  id: string;
  name: string;
  country: string;
  logo: string;
}

export interface GroupedMatches {
  [key: string]: {
    league: string;
    leagueLogo: string;
    country: string;
    matches: MatchData[];
  }
}

export interface MatchStats {
  home_team: string;
  away_team: string;
  statistics: Array<{
    type: string;
    home: string;
    away: string;
  }>;
}

export const TabsValues = {
  ALL: 0,
  LIVE: 1,
  FINISHED: 2,
  FAVORITES: 3
} as const

export type TabsType = (typeof TabsValues)[keyof typeof TabsValues]

export interface DashboardState {
  date: Date;
  tabValue: TabsType;
  leagues: League[];
  liveMatches: MatchData[];
  finishedMatches: MatchData[];
  selectedMatch: MatchData | null;
  favorites: string[];
  searchQuery: string;
  openDetailsMobile: boolean;
  selectedLeagueId: string | null;
}